import { MercuryModelSchema } from "@redotech/redo-model/conversion/mercury-model";
import * as zExt from "@redotech/rpc/ext";
import * as z from "zod/v4";

export const getAllMercuryModelsForCheckoutExperience = {
  name: "getAllMercuryModelsForCheckoutExperience" as const,
  input: z.object({ checkoutExperienceId: zExt.objectId() }),
  output: z.array(
    z.object({ mercuryModel: MercuryModelSchema, dataPointCount: z.number() }),
  ),
};
